var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { Box, Checkbox, Typography } from '@mui/material';
import CommonTable from '../../components/commonTableComponent/CommonTable';
import { tableClasses } from '../../components/commonTableComponent/CommonTableStyles';
import { BasicPopover } from '../../components/UtilityComponents/moduleTable';
import { baseColors, colors } from '../../Themes/colors';
var CHECKBOX_CHECKED_COLOR = colors.blueShades[9];
import BacklogPagination from '../backlogApplication/components/BacklogPagination';
import { toResubmitRowViewModel } from './components/resubmitRowMapper';
var stopRowClick = function (e) { return e.stopPropagation(); };
var REQ_DOCS_CORE_WEIGHTS = {
    contractIdDisplay: 14,
    customerName: 12,
    portalName: 11,
    dealerSalesRepName: 12,
    applicationDate: 15,
};
var REQ_DOCS_CORE_WEIGHT_TOTAL = Object.values(REQ_DOCS_CORE_WEIGHTS).reduce(function (sum, w) { return sum + w; }, 0);
var getReqDocsColumnWidth = function (key, hideErrorMessageColumn, isActionColumn) {
    var errorWidth = hideErrorMessageColumn ? 0 : 18;
    var actionWidth = isActionColumn ? 8 : 0;
    var coreTotal = 100 - errorWidth - actionWidth;
    return "".concat(((REQ_DOCS_CORE_WEIGHTS[key] / REQ_DOCS_CORE_WEIGHT_TOTAL) * coreTotal).toFixed(2), "%");
};
var buildColumns = function (actionHandler, canUpdate, hasDelete, isActionColumn, selectedRows, allRowIds, onToggleRow, onToggleAll, isReqDocsStage, hideErrorMessageColumn) {
    var allSelected = allRowIds.length > 0 && allRowIds.every(function (id) { return selectedRows.has(id); });
    var someSelected = !allSelected && allRowIds.some(function (id) { return selectedRows.has(id); });
    var columns = __spreadArray(__spreadArray([
        {
            key: 'contractIdDisplay',
            width: isReqDocsStage ? getReqDocsColumnWidth('contractIdDisplay', hideErrorMessageColumn, isActionColumn) : '14%',
            header: (React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 0.5 } },
                React.createElement(Box, { onClick: stopRowClick, sx: { display: 'inline-flex' } },
                    React.createElement(Checkbox, { size: "small", checked: allSelected, indeterminate: someSelected, onChange: onToggleAll, sx: { p: 0.5, '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: CHECKBOX_CHECKED_COLOR } } })),
                isReqDocsStage ? 'Transaction ID' : 'S.No.')),
            render: function (value, row) { return (React.createElement(Box, { sx: { display: 'inline-flex', alignItems: 'center', gap: 0.5, width: '100%' } },
                React.createElement(Box, { onClick: stopRowClick, sx: { display: 'inline-flex' } },
                    React.createElement(Checkbox, { size: "small", checked: selectedRows.has(row.rowKey), onChange: function () { return onToggleRow(row.rowKey, row._original); }, sx: { p: 0.5, '&.Mui-checked': { color: CHECKBOX_CHECKED_COLOR } } })),
                React.createElement(Typography, { variant: "subtitle2", sx: { color: baseColors.successPreset[30], overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, value || '—'))); },
        },
        {
            key: 'customerName',
            header: 'Customer',
            width: isReqDocsStage ? getReqDocsColumnWidth('customerName', hideErrorMessageColumn, isActionColumn) : '12%',
            render: function (value) { return React.createElement(Typography, { variant: "caption", sx: { display: 'block', px: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, value || '—'); },
        },
        {
            key: 'portalName',
            header: 'Portal',
            width: isReqDocsStage ? getReqDocsColumnWidth('portalName', hideErrorMessageColumn, isActionColumn) : '11%',
            render: function (value) { return React.createElement(Typography, { variant: "caption", sx: { display: 'block', px: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, value || '—'); },
        },
        {
            key: 'dealerSalesRepName',
            header: 'Dealer Sales Rep',
            width: isReqDocsStage ? getReqDocsColumnWidth('dealerSalesRepName', hideErrorMessageColumn, isActionColumn) : '12%',
            render: function (value) { return React.createElement(Typography, { variant: "caption", sx: { display: 'block', px: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, value || '—'); },
        },
        {
            key: 'applicationDate',
            header: 'Application Date',
            sortKey: 'applicationDate',
            sortable: true,
            width: isReqDocsStage ? getReqDocsColumnWidth('applicationDate', hideErrorMessageColumn, isActionColumn) : '15%',
            render: function (value) { return React.createElement(Typography, { variant: "caption", sx: { display: 'block', px: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, value || '—'); },
        }
    ], (hideErrorMessageColumn ? [] : [{
            key: 'errorMessage',
            header: 'Error Message',
            width: '18%',
            render: function (value) { return (React.createElement(Typography, { variant: "caption", sx: { display: 'block', px: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' } }, value || '—')); },
        }]), true), (isReqDocsStage ? [] : [{
            key: 'status',
            header: 'Status',
            width: '10%',
            render: function () { return React.createElement(Typography, { variant: "caption", sx: { display: 'block', px: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', color: baseColors.errorPreset[20], fontWeight: 600 } }, "Failed"); },
        }]), true);
    if (isActionColumn) {
        columns.push({
            key: 'action',
            header: 'Action',
            width: '8%',
            render: function (_value, row) { return (React.createElement(Box, { onClick: stopRowClick, sx: { display: 'inline-flex' } },
                React.createElement(BasicPopover, { rowData: row._original, tooltipActionHandler: actionHandler, moduleType: "Resubmit Application", scrollCounter: 0, hasDelete: hasDelete, canUpdate: canUpdate }))); },
        });
    }
    return columns;
};
var ResubmitTableSection = function (_a) {
    var _b;
    var dataToDisplay = _a.dataToDisplay, isFetching = _a.isFetching, actionHandler = _a.actionHandler, onRowClick = _a.onRowClick, canUpdate = _a.canUpdate, hasDelete = _a.hasDelete, isActionColumn = _a.isActionColumn, currentPage = _a.currentPage, perPageCount = _a.perPageCount, setCurrentPage = _a.setCurrentPage, setPerPageCount = _a.setPerPageCount, totalCount = _a.totalCount, onSelectionChange = _a.onSelectionChange, _c = _a.isReqDocsStage, isReqDocsStage = _c === void 0 ? false : _c, _d = _a.hideErrorMessageColumn, hideErrorMessageColumn = _d === void 0 ? false : _d;
    var _e = React.useState(new Map()), selectedRows = _e[0], setSelectedRows = _e[1];
    var mappedData = React.useMemo(function () {
        var _a;
        return (_a = dataToDisplay === null || dataToDisplay === void 0 ? void 0 : dataToDisplay.map(function (item, index) {
            var _a, _b;
            return (__assign(__assign({}, toResubmitRowViewModel(item, isReqDocsStage)), { rowKey: String((_b = (_a = item === null || item === void 0 ? void 0 : item.Id) !== null && _a !== void 0 ? _a : item === null || item === void 0 ? void 0 : item.ApplicationId) !== null && _b !== void 0 ? _b : index), _original: item }));
        })) !== null && _a !== void 0 ? _a : [];
    }, [dataToDisplay, isReqDocsStage]);
    var allRowIds = React.useMemo(function () { return mappedData.map(function (row) { return row.rowKey; }); }, [mappedData]);
    var handleToggleRow = React.useCallback(function (id, original) {
        setSelectedRows(function (prev) {
            var next = new Map(prev);
            if (next.has(id))
                next.delete(id);
            else
                next.set(id, original);
            return next;
        });
    }, []);
    var handleToggleAll = React.useCallback(function () {
        setSelectedRows(function (prev) {
            var allSelected = allRowIds.length > 0 && allRowIds.every(function (id) { return prev.has(id); });
            var next = new Map(prev);
            mappedData.forEach(function (row) {
                if (allSelected)
                    next.delete(row.rowKey);
                else
                    next.set(row.rowKey, row._original);
            });
            return next;
        });
    }, [allRowIds, mappedData]);
    React.useEffect(function () {
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(Array.from(selectedRows.values()));
    }, [selectedRows, onSelectionChange]);
    var columns = React.useMemo(function () { return buildColumns(actionHandler, canUpdate, hasDelete, isActionColumn, selectedRows, allRowIds, handleToggleRow, handleToggleAll, isReqDocsStage, hideErrorMessageColumn); }, [actionHandler, canUpdate, hasDelete, isActionColumn, selectedRows, allRowIds, handleToggleRow, handleToggleAll, isReqDocsStage, hideErrorMessageColumn]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { sx: (_b = {
                    '& [role="region"]': {
                        border: 'none',
                        borderRadius: 0,
                    },
                    '& .MuiTable-root': {
                        tableLayout: 'fixed',
                    },
                    '& .MuiTableCell-root': {
                        paddingTop: '0px !important',
                        paddingBottom: '0px !important',
                    }
                },
                _b["& .".concat(tableClasses.cell)] = {
                    padding: '6px !important',
                    minHeight: '40px',
                    '&:first-of-type': {
                        paddingLeft: '10px !important',
                    },
                },
                _b["& .".concat(tableClasses.cell, " > *")] = {
                    paddingLeft: '0 !important',
                },
                _b["& .".concat(tableClasses.cell, ":last-of-type .MuiIconButton-root")] = {
                    padding: '4px',
                    '& svg': {
                        width: '20px',
                        height: '20px',
                    },
                },
                _b["& .".concat(tableClasses.cellHead)] = {
                    padding: '2px !important',
                    '&:first-of-type': {
                        paddingLeft: '10px !important',
                    },
                },
                _b["& .".concat(tableClasses.empty)] = {
                    padding: '40px 16px',
                },
                _b["& .MuiTableBody-root .".concat(tableClasses.row, ":has(.Mui-checked) .").concat(tableClasses.cell)] = {
                    borderBottom: "1px solid ".concat(CHECKBOX_CHECKED_COLOR),
                },
                _b) },
            React.createElement(CommonTable, { columns: columns, data: mappedData, loading: isFetching, emptyMessage: "No Data Available", onRowClick: function (row) { return onRowClick(row._original); }, keyExtractor: function (row, index) { var _a; return (_a = row.rowKey) !== null && _a !== void 0 ? _a : index; }, "aria-label": "Resubmit Applications Table", "data-testid": "resubmit-table-section", stickyHeader: true, height: "calc(100vh - 246px)", moduleName: "Resubmit Application" })),
        React.createElement(Box, { sx: { px: '10px' } },
            React.createElement(BacklogPagination, { currentPage: currentPage, perPageCount: perPageCount, totalCount: totalCount, onPageChange: setCurrentPage, onPerPageChange: function (count) {
                    setPerPageCount(count);
                    setCurrentPage(1);
                }, className: "resubmit-pagination" }))));
};
export default ResubmitTableSection;
